export default __webpack_public_path__ + "static/media/preloader.2a9f3655.svg";